import { useContext } from "react";
import { PilotageStoreContext } from "../context/PilotageStoreContext";
import { StoreApi } from "zustand";
import { IPilotageStore } from "./usePilotageStore";

export function usePilotageStoreContext(): StoreApi<IPilotageStore> {
    return useContext(PilotageStoreContext);
}
